import React, { FC } from 'react';
import { Box, Button, Link, Typography } from '@mui/material';

import { Loaders } from 'components';

import useStyles from './styles';

interface Props {
  onClick: () => void;
  isLoading: boolean;
}

/**
 * This file doesn't use the translation engine because it
 * is expected to be changing frequently. We'll implement translation
 * when the product team adds support for non-English customers
 */
const TeamsTrial: FC<Props> = ({ onClick, isLoading }) => {
  const classes = useStyles;

  return (
    <Box textAlign="center" maxWidth={350}>
      <Typography gutterBottom variant="h2">
        Want to continue using Teams plan?
      </Typography>
      <Typography variant="h2">Upgrade now!</Typography>
      <Box paddingTop={3}>
        <Typography sx={classes.customType2}>24/mo*</Typography>
        <Typography variant="subtitle1" color="textSecondary">
          *per active user, per month
        </Typography>
      </Box>
      <Box paddingTop={3}>
        <Typography variant="subtitle1" color="textSecondary">
          Everything in Starter, plus:
        </Typography>
        <Typography variant="subtitle1">Account analytics and ROI data</Typography>
        <Typography variant="subtitle1">Gamification and leaderboards</Typography>
        <Typography variant="subtitle1">Automated content emails</Typography>
        <Typography variant="subtitle1">UTM tracking on all shares</Typography>
        <Typography variant="subtitle1">Private groups and moderators</Typography>
        <Link
          color="primary"
          display="block"
          target="_blank"
          variant="subtitle1"
          href="https://everyonesocial.com/pricing/#cm-details"
          underline="hover"
        >
          See plan details
        </Link>
      </Box>
      <Box paddingTop={3}>
        <Button
          disabled={isLoading}
          size="large"
          onClick={onClick}
          variant="contained"
          color="primary"
        >
          {isLoading ? <Loaders.Standard height={24} /> : 'Upgrade Workspace'}
        </Button>
      </Box>
    </Box>
  );
};

export default TeamsTrial;
